module.exports = __webpack_public_path__ + "assets/img/qrcode-app-a1c5218e.jpg";